import { asteroids } from '../entities/asteroids-sidecar'
import { cargoes } from '../entities/cargoes-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { distance } from '../lib/distance-sidecar'
import { scene } from '../main/scene-sidecar'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, ITask, ITaskType, registerTask } from './jobs'
import { jobs } from './jobs-sidecar'
import { tileMapShip } from '../tiles/tileMapShip-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { tilesShip } from '../tiles/tilesShip-sidecar'
import { blueprints } from '../blueprints/blueprints-sidecar'
import { common } from '../main/common-sidecar'
import { ICargoType } from '../entities/cargoesData'
import { rando } from '../lib/rando-sidecar'
import { IMachine } from '../machines/machines'
import { machines } from '../machines/machines-sidecar'
import { createTask_custom } from './taskCustom'

const type: ITaskType = 'drink'
export const register = () => registerTask(type, runTask)

export function createTask_drink(): ITask {
  return jobs._createTask(-1, -1, type, {})
}

export function runTask(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, type)
  let m = jobLogger.assertReserved(job)

  if (jobLogger.runSubtasks(job, task)) {
    return
  }

  if (jobLogger.isWaitingForPathOrMovement(job)) {
    return
  }
  const f = (c: IMachine) => c.data.type === 'water-cooler' && c.waterSupply > 0

  let mc = machines.findClosestTo(m.i, m.j, f)
  if (!mc) {
    return jobLogger.failTask(job, task, 'lost water cooler')
  }
  if (!distance.isNextToIJ(m, mc)) {
    return jobLogger.failTask(job, task, 'not next to water cooler')
  }

  // TODO: lock machine to user?

  // increase progress
  task.progress += common.getUpdateDeltaScaled()
  let time = 5
  if (task.progress < time) {
    machines.setProgress(mc, task.progress, time)
    return // Wait
  }
  machines.clearProgress(mc)

  let drinkScale = 3
  let maxDrink = (100 - m.statThirst) / drinkScale
  if (mc.waterSupply < maxDrink) {
    maxDrink = mc.waterSupply
  }

  mc.waterSupply -= maxDrink
  m.statThirst += maxDrink * drinkScale

  console.log('drank:', maxDrink, maxDrink * drinkScale)

  // // Are we at the right spot?
  // if (!distance.isNextToIJ(m, task)) {
  //   return jobLogger.failTask(job, task, 'not next to spot')
  // }

  return jobLogger.succeedTask(job, task)
}
